import { RoundedSection } from '../../../../common/RoundedSection/RoundedSection';

import Texts from './QuotesSection.texts.json';

import styles from './QuotesSection.module.scss';

export const QuotesSection = () => (
  <RoundedSection withBottomLedge withTopLedge theme="primary-mid-light-yellow">
    <div className={styles.component}>
      <h2 className={styles.title}>
        {Texts.title}
      </h2>
      <div className={styles.quoteCard}>
        <p className={styles.quote}>
          {Texts.quote}
        </p>
        <div className={styles.attribution}>
          <p className={styles.attributionText}>
            <b>{Texts.attribution.name}</b> {Texts.attribution.location}
          </p>
        </div>
      </div>
    </div>
  </RoundedSection>
);
